<div class="error-generic" *ngIf="error">
  <h2 class="error-header">Login Error</h2>
  <p>
    There was an error trying to login with the selected Google account. If the error persists, please contact
    <a href="mailto:support@kumanu.com" class="error-email-link" target="_blank">support@kumanu.com</a>
    for assistance.
  </p>
</div>
<div class="error-generic" *ngIf="!error">
  <h2 class="error-header" *ngIf="authorizingUser">Logging In</h2>
  <h2 class="error-header" *ngIf="!authorizingUser">Login Error</h2>
  <p *ngIf="authorizingUser">Finalizing user authentication...</p>
  <p *ngIf="!authorizingUser">
    There was an error trying to finalize user authentication. If the error persists, please contact
    <a href="mailto:support@kumanu.com" class="error-email-link" target="_blank">support@kumanu.com</a>
    for assistance.
  </p>
</div>
<button class="button button-pill error-button" (click)="close()">Close Window</button>
